import React, { useState } from 'react'

// import './modal_reporte.scss'

import axios from 'axios'

import { Modal } from 'react-bootstrap'

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';

import { toast } from 'react-toastify'


import moment from 'moment'


import RequestService from "../../services/request.service";

import { SERVER_ } from  '../../config';


const ModalReporte = (props) =>{

	const { onHideModalReportes, showModalReportes } = props

  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  const onChange = (dates:any) => {
    const [start, end] = dates;
    setDataReporte([])
    setStartDate(start);
    setEndDate(end);
  };

  const [ data_reporte, setDataReporte ] = useState<any>([])


  const cargarReporte = async () => {

  	try{
  		let res = await RequestService.getEndPoint('mesa_atencion/reporte/'+moment(startDate).format('YYYY-MM-DD')+'/'+moment(endDate).format('YYYY-MM-DD'))
  		setDataReporte(res.data)
  		if(res.data.length === 0) toast.warning('Este filtro no arrojó resultados')
  	}
  	catch(e){
  		toast.error('Error al intentar cargar el reporte')
  	}

  }


  const descargarReporte = async() => {
  	let res = await RequestService.downloadFile('mesa_atencion/excel/'+moment(startDate).format('YYYY-MM-DD')+'/'+moment(endDate).format('YYYY-MM-DD'))
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();
  }

const counterFromArrayField = (arr:any,tipo:string)=> {
  let sum = 0;
  if(tipo==='totales') arr.forEach((item) => sum += item.cantidad );
  if(tipo==='estatus_1') arr.forEach((item) => sum += item.estatus_1 );
  if(tipo==='estatus_2') arr.forEach((item) => sum += item.estatus_2 );
  if(tipo==='estatus_3') arr.forEach((item) => sum += item.estatus_3 );
  if(tipo==='estatus_4') arr.forEach((item) => sum += item.estatus_4 );
  if(tipo==='estatus_5') arr.forEach((item) => sum += item.estatus_5 );
  if(tipo==='estatus_6') arr.forEach((item) => sum += item.estatus_6 );
  if(tipo==='estatus_7') arr.forEach((item) => sum += item.estatus_7 );
  if(tipo==='estatus_8') arr.forEach((item) => sum += item.estatus_8 );
  if(tipo==='estatus_9') arr.forEach((item) => sum += item.estatus_9 );
  if(tipo==='estatus_999') arr.forEach((item) => sum += item.estatus_999 );

  return sum;
}

	return (

		<React.Fragment>

      <Modal backdrop="static" size="xl" dialogClassName="modal-90w" show={showModalReportes} onHide={onHideModalReportes}>
        <Modal.Header closeButton>
          <Modal.Title>Reporte de Acumulados de Trámites</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        	<div className="row">
        		<div className="col-sm-3">

        			<DatePicker selected={startDate} onChange={onChange} maxDate={new Date()} startDate={startDate} endDate={endDate} selectsRange inline />


					  <button className="btn btn-sm btn-primary" onClick={()=>{cargarReporte()}} type="button">Aplicar Filtro <i className="fa fa-filter" /></button>


        		</div>
        		<div className="col-sm-9">

        			{
        				data_reporte.length > 0 && (

        					<React.Fragment>
					        			{
					        				// JSON.stringify(data_reporte)
					        			}

					        {
					        	moment(startDate).format('YYYY-MM-DD') === moment(endDate).format('YYYY-MM-DD') && (
					        		<h6>Fecha de Filtro {moment(startDate).format('YYYY-MM-DD')}</h6>
					        	)
					        }

					        {
					        	moment(startDate).format('YYYY-MM-DD') != moment(endDate).format('YYYY-MM-DD') && (
					        		<h6>Filtro entre el {moment(startDate).format('YYYY-MM-DD')} y el {moment(endDate).format('YYYY-MM-DD')}</h6>
					        	)
					        }


							<ul className="list-inline">
							  <li className="list-inline-item"><button type="button" onClick={()=>{descargarReporte()}} className="btn btn-sm btn-link">Descargar <i className="fa fa-file-excel-o" /></button></li>
							</ul> 




							<table className="table table-sm">
							  <thead style={{fontSize:8}}>
							    <tr>
							      <th scope="col">Fecha</th>
							      <th scope="col">Día</th>
							      <th scope="col">Cantidad</th>

										<th scope="col">CAPTURA</th>
										<th scope="col">MESA DE ATENCIÓN</th>
										<th scope="col">RECTIFICACIÓN</th>
										<th scope="col">VERIFICACIÓN TELEFÓNICA</th>
										<th scope="col">ASEGURAMIENTO</th>

										<th scope="col">VERIFICACIÓN FINAL</th>
										<th scope="col">SIN PAGAR</th>
										<th scope="col">LIQUIDADO</th>
										<th scope="col">PENALIZADO</th>
										<th scope="col">CANCELADO</th>

							    </tr>
							  </thead>
							  <tbody>
							  {
							  	data_reporte.map( dia =>

							  		<React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
									    <tr>
									      <th scope="row">
									      	<small>{dia.fecha}</small>
									      </th>
									      <td>
									      	<small>{moment(dia.fecha).format('dddd')}</small>
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.cantidad}
									      </td>

									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_1}
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_2}
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_3}
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_8}
									      </td>	
									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_4}
									      </td>


									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_9}
									      </td>

									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_5}
									      </td>

									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_6}
									      </td>

									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_7}
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:10}}>
									      	{dia.estatus_999}
									      </td>





									    </tr>
							  		</React.Fragment>

							  	)
							  }

									    <tr>
									      <th colSpan={2} scope="row">
									      	
									      	
									      </th>
									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'totales') }
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_1') }
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_2') }
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_3') }
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_8') }
									      </td>	
									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_4') }
									      </td>

									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_9') }
									      </td>

									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_5') }
									      </td>

									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_6') }
									      </td>

									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_7') }
									      </td>
									      <td className="v text-right" width={35} style={{fontSize:14}}>
														{ counterFromArrayField(data_reporte,'estatus_999') }
									      </td>
									    </tr>




							  </tbody>
							</table>



        					</React.Fragment>

        				)
        			}
        		</div>
        	</div>
        	
        	

        </Modal.Body>
      </Modal>

		</React.Fragment>

	)

}


export default ModalReporte